export interface CursorInsertResult {
  value: string
  caret: number
}

export function insertTextAtRange(
  current: string,
  start: number,
  end: number,
  insertText: string,
  maxLength: number
): CursorInsertResult {
  const value = (current.slice(0, start) + insertText + current.slice(end)).slice(0, maxLength)
  const caret = Math.min(start + insertText.length, value.length)

  return { value, caret }
}
